// The site's own identity: the strings that name vit.al to a crawler, a social
// card or a JSON-LD consumer, in one place so the sitemap, llms.txt, the meta
// helper and the structured-data builders can't drift apart.
//
// Deliberately free of asset imports and of anything React — `sitemap.ts` and
// `llms.ts` are prerendered resource routes with no component, and pulling an
// image or a router type into their import graph for the sake of one constant
// would be backwards. `seo.ts` is where the og:image and the meta descriptors
// live.

// Absolute, and necessarily hardcoded: the sitemap's <loc>, llms.txt's links and
// og:url all have to be full URLs, and none of the three can derive the origin —
// two of them are prerendered against the Vite preview server on localhost.
// Preview stages therefore publish vit.al URLs, which is right: all three
// describe the canonical site, and nothing crawls a preview.
export const SITE_ORIGIN = 'https://vit.al'

// What Google should render above the URL in a SERP snippet, in place of the
// bare `vit.al` domain it currently shows. It reads the site name off the
// `WebSite` node in structured-data.ts, which is why this is the same string as
// the `| Vital Care Finder` suffix every page title carries.
export const SITE_NAME = 'Vital Care Finder'

// The shorter name the site is also known by, offered to Google as an
// alternative it may pick when the full one doesn't fit.
export const SITE_ALTERNATE_NAME = 'Vital'

// The publisher behind the site, which is a different entity from the site
// itself: the `Organization` node carries these, the `WebSite` node carries the
// two above. `vital.io` is the company's own site — vit.al is the product's, and
// is the `WebSite`'s url.
export const ORGANIZATION_NAME = 'Vital'
export const ORGANIZATION_LEGAL_NAME = 'Vital Software Inc.'
export const ORGANIZATION_URL = 'https://vital.io'

// Absolute form of an in-site path, for the places a full URL is required
// (og:url, JSON-LD `item`/`url`) and for `<link rel=canonical>`, which is
// absolute too since VIT-18029 — see `pageMeta` in seo.ts for why.
export const absoluteUrl = (path: string): string => `${SITE_ORIGIN}${path}`
